<div mat-dialog-content style="max-width: 500px">
    <div class="dialog-container custom-scroll">
        <h2>Recomandare nr #{{data.recommendationId + 1}}</h2>
        <ul>
            <li> Nume: <b>{{data.recommendation.name}}</b></li>
            <li> Recomandat de: <b>{{data.recommendation.recommendedBy}}</b></li>
            <li> Data trimiterii: <b>{{data.recommendation.postingDate}}</b></li>
            <li> Tip recomandare: <b>{{data.recommendation.recommendationType === 'company' ? 'Companie' : 'Candidat'}}</b></li>
            <li> Email: <b><a href="mailto:{{data.recommendation.email}}">{{data.recommendation.email}}</a></b></li>
            <li> Telefon: <b><a href="tel:{{data.recommendation.telephone}}">{{data.recommendation.telephone}}</a></b></li>
            <li> Facebook: <b>{{data.recommendation.facebookLink}}</b></li>
            <li> LinkedIn: <b>{{data.recommendation.linkedinLink}}</b></li>
            <li> Mesaj: <b>{{data.recommendation.message}}</b></li>
            <li> Status:
                <select [(ngModel)]="data.recommendation.status" (change)="changeStatus($event, data.recommendation.id)">
                    <option value="new">Nou</option>
                    <option value="in_progress">In progres</option>
                    <option value="done">Rezolvat</option>
                </select>
            </li>
        </ul>
    </div>
</div>
